import { VStack, HStack, NextLink } from "goi_common";
import LargeGrayButton from "./LargeGrayButton";
import { GOI_SERVICE_URL } from "@/constants/url";

const ServiceIntroduction = () => {
  return (
    <section
      css={{
        margin: "24px 0 40px",
      }}
      className="white"
    >
      <VStack gap="10px">
        <h2 className="subtitle_18_sb">서비스 소개</h2>
        <p className="body_14_r">
          무빈소 159: 조문객이 없는 장례
          <br />
          가족장 289: 조문객 50~100명 내외의 장례
          <br />
          일반장 389: 조문객 200명 이상의 장례
        </p>
      </VStack>
      <HStack
        css={{
          marginTop: "12px",
          ["a"]: {
            width: "100%",
          },
        }}
        gap="10px"
      >
        <NextLink href={GOI_SERVICE_URL}>
          <LargeGrayButton>사이트 바로가기</LargeGrayButton>
        </NextLink>
        <NextLink href={`${GOI_SERVICE_URL}/service/`}>
          <LargeGrayButton>가격 보기</LargeGrayButton>
        </NextLink>
      </HStack>
    </section>
  );
};

export default ServiceIntroduction;
